import { render } from "./TalkFutureTalents.vue?vue&type=template&id=9a75216c&scoped=true&ts=true&lang=pug"
import script from "./TalkFutureTalents.vue?vue&type=script&lang=ts"
export * from "./TalkFutureTalents.vue?vue&type=script&lang=ts"

import "./TalkFutureTalents.vue?vue&type=style&index=0&id=9a75216c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a75216c"]])

export default __exports__